import React from "react";
import { FlagOutlined } from "@ant-design/icons";
import styled from "styled-components";

const EmptyState = styled.div`
	display: grid;
	width: 100%;
	height: 100%;
	min-height: 0;
	place-items: center;
	color: #777;
`;

const Content = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	gap: 10px;
	text-align: center;

	.anticon {
		margin-bottom: 8px;
		color: #999;
		font-size: 26px;
	}
`;

const Title = styled.div`
	color: #666;
	font-size: 16px;
	font-weight: 600;
`;

const Description = styled.div`
	color: #777;
	font-size: 14px;
`;

export const EngagementTermsEmptyState: React.FC = () => (
	<EmptyState>
		<Content>
			<FlagOutlined />
			<Title>No markets added yet</Title>
			<Description>Add a market first in the “Markets” tab</Description>
		</Content>
	</EmptyState>
);
